<template>
  <button class="Drop-Menu-Item" @click="handleClick">
    <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="Drop-Menu-Item__icon" style="overflow: visible;"><path d="M10 2C7.23858 2 5 4.23858 5 7V9.58579C5 10.1166 4.78929 10.6267 4.41421 11L3.29289 12.1213C2.90237 12.5118 3.17707 13.1716 3.70711 13.1716H16.2929C16.8229 13.1716 17.0976 12.5118 16.7071 12.1213L15.5858 11C15.2107 10.6267 15 10.1166 15 9.58579V7C15 4.23858 12.7614 2 10 2Z" stroke="#888" stroke-width="1.5"/><path d="M8 16C8 17.1046 8.89543 18 10 18C11.1046 18 12 17.1046 12 16" stroke="#888" stroke-width="1"/></svg>
    Push-уведомления
    <SwitchButton class="Switch-button Drop-Menu-Item__side" :isOn="isGranted" />
  </button>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import SwitchButton from "@ui/Fields/SwitchButton/SwitchButton.vue";
import { subscribeUserToPush, unsubscribeUserFromPush, checkPushSubscription } from '@shared/services/push_notifications/push.js';

const isGranted = ref(false);

onMounted(async () => {
  isGranted.value = await checkPushSubscription();
});

async function handleClick() {
  if (isGranted.value === true) {
    // Если уже разрешено, то отключаем
    await unsubscribeUserFromPush();
    isGranted.value = false;
    return;
  } else {
    // Если не разрешено, то запрашиваем разрешение
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      isGranted.value = true;
      await subscribeUserToPush();
    }
  }
}
</script>

<style lang="scss">
  @import '../../../../styles/Drop-Menu-Item.scss';
</style>
